/* globals Class,lp */

;(function(){
  lp.editor.SectionTransformBoxHandleHelper = Class.create(lp.editor.TransformBoxHandleHelper, {
    handleDragTop: null,
    handleDragLeft: null,
    handleDragRight: null,
    handleDragTopRight: null,
    handleDragTopLeft: null,
    handleDragBottomRight: null,
    handleDragBottomLeft: null,
    handleDragBottom: function(dragOffset) {
      var w0 = this.elmStartSize.width;
      var h0 = this.elmStartSize.height;
      var minSize = this.elmMinSize;
      var maxSize = this.elmMaxSize;
      var ar = w0 / h0;

      var heightDiff = this.editor.mainPage.getRootElement().isDisplayPositionBottom() ?
        -dragOffset.top : dragOffset.top;

      var startOffset = {left: this.elmStartRootOffset.left, top: this.elmStartRootOffset.top + h0};
      var newOffset = {left: startOffset.left + dragOffset.left, top: startOffset.top + heightDiff};

      this._snapPoint(newOffset);

      var w;
      var h = Math.min(maxSize.height, Math.max(minSize.height, h0 + heightDiff));
      if (this._maintainAR()) {
        w = Math.round(h * ar);
        if (w >= maxSize.width || w <= minSize.width) {
          w = Math.min(maxSize.width, Math.max(minSize.width, w));
          h = Math.min(maxSize.height, Math.max(minSize.height, Math.round(w / ar)));
        }
      } else {
        w = w0;
      }

      this.model.suppressEvents();
      this.model.setSize({width: w, height: h});
      this.model.releaseEvents();
    }
  });
})();



//////////////////
// WEBPACK FOOTER
// ./src/legacy/lp/editor/section_transform_box_handle_helper.js
// module id = 1029
// module chunks = 0